import { AuthPainelService } from './../login/auth-painel.service';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { AuthService } from '../login/auth.service';
import { catchError, throwError } from 'rxjs';
import { SessionService } from '../login/session.service';
import { PUBLIC_IDENTITY_API_ROUTES } from '../user/identity-routes';

export const authInterceptor: HttpInterceptorFn = (req, next) => {

  const paginasPublicasExatas = [
    "/home",
    "/treino",
    "/materias",
    "/ferramentas",
    "/politica-privacidade",
    "/contato",
    "/eventos",
    "/eventos/contato"
  ];

  const paginasPublicasPorPrefixo = [
    "/treino/leitura",
    "/materias/leitura",
    "/eventos/evento",
    "/eventos/evento/lista-inscritos",
    "/eventos/evento/ranking",
    "/eventos/evento/fazer-inscricao-sem-login",
    "/eventos/nova-senha"
  ];

  const apiPublicas = [
    "v1/eventos-apresentacao",
    "v1/eventos/",
    "v1/eventos-compartilhamento/",
    "v1/contato",
    ...PUBLIC_IDENTITY_API_ROUTES,
    "v1/inscritos/finalizar-inscricao-terceiros-sem-login",
    "v1/inscritos/consultar-categorias-para-terceiros",
    "v1/materias",
    "v1/treinos"
  ];

  const apisSempreSemToken = [
    "/assets/i18n/"
  ];



  if (req.url.includes("-painel")) {
    const authPainelService = inject(AuthPainelService);
    const sessionService = inject(SessionService);
    const token = sessionService.getPainelToken();


    const authReq = authPainelService.recuperarToken()
      ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
      : req;

    return next(authReq).pipe(
      catchError((error) => {
        if (error.status === 401) {
          authPainelService.deslogarClienteTokenInvalido();
        }
        return throwError(() => error);
      })
    );
  }
  else {
    //Variaveis
    const authService = inject(AuthService);
    const sessionService = inject(SessionService);
    const document = inject(DOCUMENT);
    const pathPaginaAtualUsuario = document.location?.pathname || '/';

    if (typeof window !== 'undefined') {
      authService.salvarUltimaUrl(pathPaginaAtualUsuario);
    }

    //Valida página pública
    const flPaginaPublica =
      paginasPublicasExatas.includes(pathPaginaAtualUsuario) ||
      paginasPublicasPorPrefixo.some(path =>
        pathPaginaAtualUsuario === path || pathPaginaAtualUsuario.startsWith(`${path}/`)
      );

    //Valida api pública
    const flApiPublica = apiPublicas.some(rota =>
      req.url.includes(rota)
    );

    const flApiSempreSemToken = apisSempreSemToken.some(rota =>
      req.url.includes(rota)
    );

    if (flApiSempreSemToken || (flPaginaPublica && flApiPublica)) {
      return next(req).pipe(
        catchError((error: HttpErrorResponse) => { return throwError(() => error); })
      );
    }

    const token = sessionService.getAuthToken();

    const authReq = authService.recuperarToken()
      ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
      : req;

    return next(authReq).pipe(
      catchError((error: HttpErrorResponse) => {

        //Deu erro na api
        if (error.status === 401 && !error.url?.includes("autenticacao") && !flPaginaPublica) {
          authService.deslogarClienteTokenInvalido();
        }
        else if (!error.url?.includes("autenticacao")) {
          const now = new Date().getTime();
          const tempoToken = sessionService.getAuthTokenExpiration();
          if (((tempoToken && tempoToken < now) || !token) && !flPaginaPublica) {
            authService.deslogarClienteTokenInvalido();
          }
        }
        return throwError(() => error);
      })
    );
  }
};
